import imEngine from '@/utils/imEngine';

/**
 * IM 宿主 mixin：注册 $refs 供 imEngine 调用，并在销毁时注销。
 */
export default {
	created() {
		imEngine.registerHost(this, {
			shouldSuppressNotification: () => this.imShouldSuppressNotification(),
		});
	},
	beforeDestroy() {
		imEngine.unregisterHost(this);
	},
	methods: {
		imShouldSuppressNotification() {
			return false;
		},
		imEnsureStarted() {
			return imEngine.ensureStarted(this);
		},
		imOnExit() {
			imEngine.onExit(this);
		},
		imCloseAllBox() {
			this.$refs.groupInfo?.close();
			this.$refs.userInfo?.close();
		},
	},
};
